import { useMemo } from 'react';
import { ProductDetailsProps } from '..';
import Link from '../../../../atoms/link';

type WoodFinishHelperProps = ProductDetailsProps['woodFinishHelper'] & { className?: string };
export const WoodFinishHelper = ({ link, linkLabel, text, className = '' }: WoodFinishHelperProps) => {
  const { prefix, linkContent, suffix } = useMemo(() => {
    const value = { prefix: text, linkContent: '', suffix: '' };

    if (!linkLabel || !text) return value;

    const start = text?.indexOf(linkLabel);

    if (!start || start === -1) return value;

    const end = start + linkLabel.length - 1;

    value.prefix = text.substring(0, start);
    value.linkContent = text.substring(start, end + 1);
    value.suffix = text.substring(end + 1);

    return value;
  }, [link, linkLabel, text]);

  return (
    <p className={`body-text flex flex-wrap items-center gap-x-8 ${className}`}>
      {prefix}
      <Link showExternalIcon variant="primary" link={link} className="body-text">
        {linkContent}
      </Link>
      {suffix}
    </p>
  );
};
